import { render } from "./PersonalDetails.vue?vue&type=template&id=4a3dc2c6&scoped=true"
import script from "./PersonalDetails.vue?vue&type=script&lang=js"
export * from "./PersonalDetails.vue?vue&type=script&lang=js"

import "./PersonalDetails.vue?vue&type=style&index=0&id=4a3dc2c6&lang=scss&scoped=true"

import exportComponent from "D:\\Vue-apps\\HIDABROOT\\hdb_memorial\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a3dc2c6"]])

export default __exports__